export default function routeDeerFlowMessage(options) {
    const {
        curSkillRef,
        currentMsg,
        currentSessionMapIdRef,
        linkToSession,
        deerFlowHook,
        processing,
        msgList,
        localsession_key,
        sessionListRef,
        sessionMapRef,
        formatSessionList,
        changeSessionMapItem,
        isInAnswerRef,
        side
    } = options || {};

    // 判断是否为 DeerFlow 聊天
    const isDeerFlow = curSkillRef?.current?.third_json?.handler === 'deerflow';
    let effectiveSessionId = currentMsg?.session_id;

    if (!isDeerFlow) {
        return null;
    }

    if (!currentSessionMapIdRef?.current || currentSessionMapIdRef.current === '') {
        if (effectiveSessionId) {
            // 不直接在 hook 中修改外部 ref；把 sessionId 返回给调用方（store）由其统一设置。
            // 但可以触发跳转（如果调用方提供了 linkToSession），调用方也可以选择自己跳转。
            try {
                linkToSession?.(effectiveSessionId, { replace: true });
            } catch (e) {
                // ignore
            }
        }
    } else {
        // 已存在会话ID，使用已有的
        effectiveSessionId = currentSessionMapIdRef.current;
    }

    // 使用 DeerFlow hook 处理消息更新
    try {
        deerFlowHook?.handleDeerFlowMessageUpdate(currentMsg, processing, msgList, localsession_key, {
            currentSessionMapIdRef,
            sessionListRef,
            sessionMapRef,
            formatSessionList,
            linkToSession,
            delayedStartTimers: deerFlowHook?.delayedStartTimers,
            changeSessionMapItem,
            isInAnswerRef,
            side,
            effectiveSessionId
        });
    } catch (e) {
        console.warn('routeDeerFlowMessage error:', e);
    }

    return effectiveSessionId;
}


